export enum DoctorWorkState{
    Free,
    Started,
    Busy
}